import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../constants/api-endpoints';
import { HttpRequesterService } from '../http-requester.service';

@Injectable({ providedIn: 'root' })
export class PolicyHolderService {
  constructor(private http: HttpRequesterService) {}

  registerPolicyHolder(formData: any): Observable<any> {
    return this.http.post(ApiEndpoints.Policyholder.Register, formData);
  }

  getPolicyHolderById(id: number | string): Observable<any> {
    return this.http.get(ApiEndpoints.Policyholder.GetById(id));
  }

  getAllPolicyHolders(filters: any): Observable<any> {
    

    return this.http.get(ApiEndpoints.Policyholder.GetAll, filters);
  }

  updatePolicyHolder(id: number | string, changes: any): Observable<any> {
    return this.http.put(ApiEndpoints.Policyholder.UpdateById(id), changes);
  }
}
